import React from 'react';
import logo from './logo.svg';
import './assets/css/App.css';
import { Route, Routes, BrowserRouter as Router, Link } from "react-router-dom";
import HeaderComponent from './screens/header/HeaderScreen';
import HomeComponent from './screens/home/HomeScreen';
import ClothComponent from './screens/cloths/ClothScreen';
import FooterComponent from './screens/footer/FooterScreen';
import ProductDetaisComponent from './screens/productsdetails/ProductDetailsScreen';
import ViewCartScreen from './screens/viewcart/viewcartscreen';
import { toast } from 'react-toastify';
toast.configure()

function App() {


  return (
    <>
      <Router>
        <div>
          <HeaderComponent />
          <div style={{ minHeight: '100vh', overflowX: 'hidden' }}>
            <Routes>
              <Route path="/" element={<HomeComponent />} />
              <Route path="clothscreen" element={<ClothComponent />} />
              <Route path="productdetails" element={<ProductDetaisComponent />} />
              <Route path="viewcart" element={<ViewCartScreen />} />
            </Routes>
          </div>
          <FooterComponent />
        </div>
      </Router>
    </>
  );
}

export default App;
